import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Modal from 'react-bootstrap/Modal';


import HOME_BANNER from '../../images/home_banner.png';
import SAMURAI_BANNER from '../../images/SamuraiLogo.png';
import RoninBig from '../../images/RoninBig.png';
import ShogunBig from '../../images/ShogunBig.png';
import RoninSmallOn from '../../images/RoninSmallOn.png';
import ShogunSmallOn from '../../images/ShogunSmallOn.png';
import RoninSmallOff from '../../images/RoninSmallOff.png';
import ShogunSmallOff from '../../images/ShogunSmallOff.png';
import LearnMoreLine from '../../images/LearnMoreLineLogin.png';
import SamuraiLine from '../../images/SamuraiLine.png';
import RoninSmallLogin from '../../images/RoninSmallLogin.png';
import AolSmallLogin from '../../images/AolSmallLogin.png';
import ShogunSmallLogin from '../../images/ShogunSmallLogin.png';
import Footer from '../Footer';
import SideBar from '../SideBar';
import SideBarSmallScreen from '../SideBarSmallScreen';
import { roninURL, roninHealthInfoURL, shogunURL } from '../../config';

import '../../../src/styles/home.css';

const Home = () => {
    const [selectedApp, setSelectedApp] = useState('');
    const [selectedVideoId, setSelectedVideoId] = useState("");
    const [selectedYouTubeApp, setSelectedYouTubeApp] = useState("");
    const [showYoutube, setShowYoutube] = useState(false);
    const [selectedBottomModalTitleImage, setSelectedBottomModalTitleImage] = useState(null);

    const fetchUserResponse = useSelector((state) => state.fetchUserResponse); // {SHOGUN: 1, RONIN: 1}; 1 means the application exists

    const hostName = window.location.hostname;
    console.log(`hostName: ${hostName}`);

    const handleBottomBtn = (app) => {
        setShowYoutube(true);
        setSelectedYouTubeApp(app); // Set the selected YouTube app
        const videoIds = {
            RONIN: "B7UDtvwJpSk", // Replace with actual video ID for RONIN
            AOL: "d60z_SqQ17Y",   // Replace with actual video ID for AOL
            SHOGUN: "1kRL-xYQXCM", // Replace with actual video ID for SHOGUN
        };
        const homeBottomModalImage = {
            RONIN: RoninSmallOn,
            AOL: AolSmallLogin,
            SHOGUN: ShogunSmallOn,
        };

        setSelectedVideoId(videoIds[app] || ""); // Set the selected video ID
        setSelectedBottomModalTitleImage(homeBottomModalImage[app] || null);

       
    };
    console.log(`Selected video for ${selectedYouTubeApp}: ${selectedVideoId}`);
    console.log(`showYoutube: ${showYoutube}`);


    useEffect(() => {
        let isSHOGUN = fetchUserResponse.SHOGUN;
        let isRONIN = fetchUserResponse.RONIN;
       
        setSelectedApp(isRONIN ? 'RONIN' : isSHOGUN ? 'SHOGUN' : '');
      }, [fetchUserResponse]);

      console.log(`selectedApp: ${selectedApp}`);

    

    const navigate = useNavigate();
    const user = window.localStorage.getItem('email');
    const isSmallScreen = window.innerWidth < 600;

    

    // if isRONIN is true, then the HOME_BANNER should be RoninBig
    // if isRONIN is false but isSHOGUN is true, then the HOME_BANNER should be ShogunBig
    // if isRONIN and isSHOGUN are false, then the HOME_BANNER should be HOME_BANNER

    const handleExternalNavigation = () => {
        let externalUrl = selectedApp === 'RONIN' ? roninHealthInfoURL : shogunURL;      
        window.open(externalUrl, "_blank"); // Open in a new tab
    };    
      

    // handle the bottom button for SHOGUN
    const handleSelectSHOGUN = () => {
        if ( fetchUserResponse.SHOGUN === 1) {
            setSelectedApp('SHOGUN')
        } else {
            handleBottomBtn('SHOGUN')
        }
    }
 
    return (
        <>
        {
            !isSmallScreen && 
            <div>
                <SideBar />
            </div>
        }
        <div className='home-container'>
            <div className={ user ? 'home-banner-container' : 'home-banner-container-no-login'}>
                {
                    selectedApp === 'RONIN' ?
                        <img src={RoninBig} alt='SAMURAI' className={ user ? 'home-image-loggedin' : 'home-image' }></img>
                        :
                    selectedApp === 'SHOGUN' ?
                        <img src={ShogunBig} alt='SAMURAI' className={ user ? 'home-image-loggedin' : 'home-image' }></img>
                        :
                        <img src={ user ? SAMURAI_BANNER : HOME_BANNER} alt='SAMURAI' className={ user ? 'home-image-loggedin' : 'home-image' }></img>
                }
            </div>
            <div className='home-btn-container'>
                {user ? 
                (                    
                   
                    <div className='home-middle-btn--container'>
                        <button className='home-btn-loggedin'  onClick={handleExternalNavigation}>Go to the Analytic Dashboard</button>
                        <div>
                            <img src={SamuraiLine} alt='SAMURAI' className='learn-more-line-login'></img>
                            <div className='home-bottom-apps-btn--container'>                       
                                <div >
                                    <button className='home-btn--app--item' onClick={() => setSelectedApp('RONIN')}>
                                        <img src={ fetchUserResponse.RONIN === 1 ? RoninSmallOn : RoninSmallOff} alt='RONIN' className='home-image-small' ></img>
                                    </button>                            
                                </div>
                                <div className='home-btn--app--item'>
                                    <button  className='home-btn--app--item' onClick={ handleSelectSHOGUN } >
                                        <img src={ fetchUserResponse.SHOGUN ===1 ? ShogunSmallOn : ShogunSmallOff } alt='SHOGUN' className='home-image-small'></img>
                                    </button>                           
                                </div>                        
                            </div>
                        </div>
                    </div>
                ) :
                <div className='home-middle-btn--container'>
                    <button className='home-btn' onClick={() => navigate("/auth/signin")}>Please login to continue</button>
                    <div>
                        <img src={LearnMoreLine} alt='SAMURAI' className='learn-more-line-login'></img>
                        <div className='home-bottom-apps-btn--container'>
                           <button className='home-btn--bottom-image' onClick={() => handleBottomBtn('RONIN')}>
                                <img src={RoninSmallLogin} alt='RONIN' className='home-image-small'></img>
                           </button>
                           <button className='home-btn--bottom-image' onClick={() => handleBottomBtn('AOL')}>
                                <img src={AolSmallLogin} alt='AOL' className='home-image-small'></img>
                           </button >
                            <button className='home-btn--bottom-image' onClick={() => handleBottomBtn('SHOGUN')}>
                                <img src={ShogunSmallLogin} alt='SHOGUN' className='home-image-small'></img>
                            </button>

                           
                        </div>
                    </div>
              
                </div>
                }

                {/* Youtube Modal */}
                <Modal show={showYoutube} onHide={() => setShowYoutube(false)} size='lg' centered className='home-bottom-modal'>
                    <Modal.Header >
                        <Modal.Title className='home-bottom-modal-title-container'>                         
                            <img src={selectedBottomModalTitleImage} alt='AOL' className='home-bottom-modal-title-image'></img>
                            <button className='home-bottom-modal-title-skip-btn' onClick={() => setShowYoutube(false)}>
                                <span className='home-bottom-modal-title-skip-text'>Skip</span>
                                <span className='home-bottom-modal-title-skip-icon'>&#10174;</span>
                            </button>                          
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className='video-responsive'>
                            <iframe
                                width="853"
                                height="480"
                                src={`https://www.youtube.com/embed/${selectedVideoId}?autoplay=1`}
                                title="YouTube video player"                        
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            ></iframe>
                        </div>
                    </Modal.Body>
                </Modal>
               
            </div> 
         
        </div>
       
        {isSmallScreen ? (
                      <SideBarSmallScreen />
                    ) : null
        }
        <div className={ user ? 'home-footer-container' : 'home-footer-container-no-login'}>
            <Footer />
        </div>
        </>
  );
};

export default Home;
